export const FETCH_NBR_LIST = 'FETCH_NBR_LIST';
export const SET_LIST = 'SET_LIST';
